export default "__VITE_ASSET__DXEtlIO___"